import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 1rem;
    gap: 0.75rem;
  }
`;

export const ContainerFiltrosAudiencia = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background: ${(props: any) => props.theme.colors.cf8f9fa};
  border: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
  border-radius: 8px;
  margin: 0.5rem 0;

  @media (max-width: 768px) {
    padding: 1rem;
    gap: 0.75rem;
  }
`;

export const TituloFiltrosAudiencia = styled.h3`
  font-size: 0.875rem;
  font-weight: 700;
  color: ${(props: any) => props.theme.colors.c2d3748};
  text-transform: uppercase;
  margin: 0 0 0.5rem 0;
  letter-spacing: 0.05em;
`;

export const CampoFiltro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: visible;

  &.campo-valor,
  &.campo-data {
    flex-direction: row;
    gap: 1rem;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 0.75rem;
    }

    > div {
      flex: 1;
    }
  }

  /* Uniformiza a cor e peso dos títulos dos inputs padrão
     (NÚMERO DO PROCESSO/IDENTIFICAÇÃO, PARTE ENVOLVIDA, PARTE REPRESENTADA)
     para coincidir com os demais títulos de filtros */
  .default-input .title {
    color: ${(props: any) => props.theme.colors.c2d3748};
    font-weight: 600;
  }
`;

export const SelectServico = styled.select`
  width: 100%;
  height: 48px;
  padding: 0 1rem;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.interfaceText400};
  font-size: 0.875rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primaryBlue400};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryBlue100};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.interfaceBorder200};
  }

  option {
    padding: 0.5rem;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.interfaceText400};
  }
`;

export const SelectAreaDireito = styled.select`
  width: 100%;
  min-height: 48px;
  padding: 0.5rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.interfaceText400};
  font-size: 0.875rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primaryBlue400};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryBlue100};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.interfaceBorder200};
  }

  option {
    padding: 0.5rem;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.interfaceText400};
  }
`;

export const TituloCampo = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceText400};
  margin-bottom: 0.25rem;

  &::after {
    content: '*';
    color: ${({ theme }) => theme.colors.primaryRed400};
    margin-left: 0.25rem;
  }
`;

export const GridCampos = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
`;

export const GrupoCampos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SubtituloGrupo = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceText400};
  margin: 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid ${({ theme }) => theme.colors.interfaceBorder100};
`;

export const SelectOperador = styled.select`
  width: 123px;
  height: 48px;
  padding: 0 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.interfaceText400};
  font-size: 0.875rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;
  flex-shrink: 0;

  &:focus {
    outline: none;
    border-color: ${(props: any) => props.theme.colors.c000000};
    box-shadow: 0 0 0 1px ${(props: any) => props.theme.colors.c000000};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.interfaceBorder200};
  }

  option {
    padding: 0.5rem;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.interfaceText400};
  }
`;
